import React, { useCallback } from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import FormLayout from "@mapmycustomers/shared/types/layout/FormLayout";
import { EditableText } from "@mapmycustomers/ui";

import { RootState } from "@app/store/rootReducer";

import { getEditedLayout, isSaving } from "../../store";
import { updateLayout } from "../../store/actions";

import styles from "./Title.module.scss";

interface Props {
  layout?: FormLayout;
  onUpdateLayout: typeof updateLayout;
  saving: boolean;
}

const messages = defineMessages({
  titleRequired: {
    id: "settings.formLayouts.modal.title.saveButton.titleRequired.tooltip",
    defaultMessage: "Non-empty title is required",
    description: "Title is required tooltip",
  },
});

const Title: React.FC<Props> = ({ layout, onUpdateLayout, saving }) => {
  const intl = useIntl();

  const handleChange = useCallback(
    (name: string) => {
      onUpdateLayout({ name });
    },
    [onUpdateLayout]
  );

  if (!layout) {
    return null;
  }

  return (
    <EditableText
      fieldClassName={styles.field}
      onChange={handleChange}
      required
      requiredTooltip={intl.formatMessage(messages.titleRequired)}
      saving={saving}
      value={layout?.name}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  layout: getEditedLayout(state),
  saving: isSaving(state),
});

const mapDispatchToProps = {
  onUpdateLayout: updateLayout,
};

export default connect(mapStateToProps, mapDispatchToProps)(Title);
